import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/legacy/Terms.tsx");
